
import {
  formatOpeningDayGroups,
  openingDayGroups,
  openingHoursLine,
} from '@/utils/storeOpeningHours'

export default {
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    weekday: {
      type: String,
      default: 'long',
    },
    withClosedDays: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    week() {
      return this.$store.getters.store_opening_week
    },
    line() {
      return openingHoursLine(this.week, this.$i18n.locale, this.weekday)
    },
    groups() {
      return formatOpeningDayGroups(
        openingDayGroups(this.week, { withClosedDays: this.withClosedDays }),
        this.$i18n.locale,
        this.weekday
      )
    },
  },
}
